import React from 'react';
import { ThemeProvider } from './ThemeContext';
import './style/theme.scss';
import './style/variables.scss';
import { HelmetProvider } from 'react-helmet-async';
import './style/App.scss';
import AppRoutes from './AppRoutes';
import SEO from './components/SEO';
import QConnect from './components/QConnect';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <SEO
          title="Quartermaster"
          description="Create powerful AI agents with our visual IDE. Integrate with GPT-4, Claude, and Groq. Join 2000+ creators building the future of AI automation. Start for free today!"
          path="/"
        />
        <QConnect />
        <AppRoutes />
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
